import EmailIcon from "@mui/icons-material/Email";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useGoogleLogin } from "@react-oauth/google";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import flowChangerLogo from "../../../../Assets/Images/flowchangerAINew.jpeg";
import loginLady from "../../../../Assets/Images/login-lady.png";
import loginSlash from "../../../../Assets/Images/login-slash.jpeg";
import { useAuthContext } from "../../../../Context/AuthContext";
import { useGlobalContext } from "../../../../Context/GlobalContext";

const LoginPage = () => {
  const login = useGoogleLogin({
    onSuccess: (codeResponse) => {
      setUser(codeResponse);
    },
    onError: (error) => console.log('Login Failed:', error)
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { isAuthenticated, setIsAuthenticated, setStep } =
    useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  const { openToast, baseUrl } = useGlobalContext();
  const { setUser, user, setProfile } = useAuthContext();
  console.log(clientId);
  const navigate = useNavigate();
  const googleButtonStyle1 = `
  w-full flex items-center justify-center gap-3 
  bg-white hover:bg-gray-50 
  text-gray-700 font-medium
  py-3 px-4 
  border border-gray-300 
  rounded-full
  shadow-md hover:shadow-lg
  transform transition duration-200 ease-in-out
  hover:scale-[1.01]
`;

  const fetchProfile = async () => {
    if (user) {
      try {
        const res = await fetch(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: "application/json",
            },
          }
        );

        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }

        const data = await res.json();
        // navigate("/authentication/confirm-password");
        setProfile(data);
      } catch (err) {
        console.error("Error fetching user profile:", err);
      }
    }
  };

  useEffect(() => {
    if (user) {
      navigate("/authentication/confirm-password");
    }
    fetchProfile();
  }, [user]);

  // useEffect to handle the navigation
  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/authentication/login");
    } else {
      setIsAuthenticated(true);
      navigate("/");
    }
  }, [isAuthenticated]);

  const handleLoggedIn = async (loginInfo) => {
    console.log(loginInfo);
    try {
      const response = await fetch(baseUrl + "user/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(loginInfo),
      });
      console.log(response);
      const result = await response.json();
      console.log(result, "sjdfoijaskdjfhih")
      if (response.status === 403) {
        alert("403");
        openToast(result.message || "Login failed", "error");
        const email = loginInfo.email;
        console.log("navigate to step3", email);
        setStep(3);
        navigate(`/authentication?step=3&email=${encodeURIComponent(email)}`);
      } else if (response.status === 200) {
        openToast("You have successfully logged in", "success");
        console.log("You have logged in");

        const {
          token,
          user: { role },
        } = result;

        Cookies.set("flowChangerAuthToken", token);
        setIsAuthenticated(true);
        role === "CLIENT" ? navigate("/c") : navigate("/");
        return true;
      } else {
        console.log("there is no token");
        openToast(result.message || "Login failed", "error");
        console.log("can't logged in");
        return false;
      }
    } catch (error) {
      console.error("Login error:", error);
      openToast("An error occurred. Please try again.", "error");
      return false;
    }
  };


  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      console.log(data);
      const LoginInfo = {
        email: data.email.toLowerCase(),
        password: data.password,
      };
      const success = await handleLoggedIn(LoginInfo);
      if (success) {
        console.log("Login successful and user authenticated");
      }
    } catch (error) {
      console.error("Login error:", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="flex justify-center items-center px-[10px] md:px-[20px] lg:px-[10px] xl:px-[10px] py-[0px] md:py-[20px] lg:py-[20px] xl:py-[20px] h-lvh min-h-screen overflow-y-auto">
      <div className="flex justify-center bg-white rounded-lg w-[100%] lg:w-[100%] xl:w-[80%] login-div">
        <div className="w-[100%] md:w-[50%] lg:w-[50%] xl:w-[50%]">
          <div className="space-y-2 sm:space-y-0 lg:px-[62px] xl:px-[30px] py-[40px] md:p-[30px] w-full">
            <div className="flex justify-center items-center">
              <img src={flowChangerLogo} className="w-[120px]" />
            </div>

            <div className="mt-[12px]">
              <p className="mt-[10px] pb-2 text-[#8c8c8c] text-[14px] text-center">
                Please Login to Continue
              </p>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <button onClick={login} className={`font-medium text-[#8a25b0] text-center w-full md:w-[50%]  bg-[#8a25b1] border-[#8a25b0] rounded-full border  py-[8px] px-4 ${isLoading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#8a25b0]"
                } text-white py-[8px] px-4 hover:bg-[#884a9f] transition duration-300 rounded-full`}
              >Login with Google </button>
            </div>
            <div className="flex items-center my-4">
              <div className="flex-grow border-gray-200 border-t"></div>
              <span className="mx-4 text-gray-500">or</span>
              <div className="flex-grow border-gray-200 border-t"></div>
            </div>

            <div className="flex justify-center items-center my-4"></div>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="space-y-2 sm:space-y-0 mt-4 sm:mt-0"
            >
              <div className="relative mb-4">
                <input
                  type="email"
                  placeholder="Email"
                  aria-label="Email"
                  className="login-input-field"
                  {...register("email", { required: "email is required" })}
                />
                {errors.email && (
                  <p className="text-red-500 text-xs">{errors.email.message}</p>
                )}
                <EmailIcon className="top-[10px] right-[13px] absolute text-[#8a25b0] email-icon" />
              </div>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  aria-label="Password"
                  className="login-input-field"
                  {...register("password", {
                    required: "password is required",
                  })}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="top-[4px] right-[13px] absolute"
                >
                  {showPassword ? (
                    <VisibilityIcon className="top-[7px] right-[0px] absolute text-[#8a25b0] email-icon" />
                  ) : (
                    <VisibilityOffIcon className="top-[7px] right-[0px] absolute text-[#8a25b0] email-icon" />
                  )}
                </button>
              </div>
              <div className="flex justify-right items-center py-4">
                <Link
                  to="/authentication/request-password"
                  className="mr-2 text-gray-400 hover:text-[#8a25b0]"
                >
                  Forgot password?
                </Link>

              </div>
              <div className="flex md:flex-row flex-col justify-between items-center gap-[10px] md:gap-[10px] w-full">
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`font-medium text-[#8a25b0] text-center w-full md:w-[50%]  bg-[#8a25b1] border-[#8a25b0] rounded-full border  py-[8px] px-4 ${isLoading
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[#8a25b0]"
                    } text-white py-[8px] px-4 hover:bg-[#884a9f] transition duration-300 rounded-full`}
                >
                  Log in
                </button>
                <Link
                  to="/authentication?step=1"
                  className="border-[#8a25b1] px-4 py-[8px] border rounded-full w-full md:w-1/2 font-medium text-[#8a25b0] text-center"
                >
                  Sign up
                </Link>
              </div>
            </form>
          </div>
        </div>
        <div className="relative login-right md:flex justify-center items-center hidden bg-[#9181F4] px-[30px] py-[10px] w-[50%] md:w-[50%] lg:w-[50%] xl:w-[50%] text-4xl text-center">
          <div className="relative border-[#bfbfbf66] bg-[#e2e0e938] border rounded-xl w-[80%] h-[83%]">
            <h2 className="p-[18px] w-[212px] font-bold text-[32px] text-left text-white md:text-[22px]">
              Very good works are waiting for you Login Now!!!
            </h2>
            <div className="top-[-6px] right-[-42px] bottom-[0px] absolute">
              <img src={loginLady} alt="loginLady" className="h-[100%]" />
            </div>
            <div className="left-[-20px] absolute bg-white p-[10px] rounded-full">
              <img src={loginSlash} alt="loginSlash" className="rounded-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
